import {addAuthToFetchOpts} from '../config/queryopts'
import {useMutationWithAuthentication} from "./index";
import {apiUrlInternal} from "../config/api"
import axios from "axios";
import {useQueryClient} from "react-query";


export const AddResourceMonitorProjectFetcher = (accessToken, organizationUid, params) => {
  return axios.post(
    `${apiUrlInternal}/resource_monitor_projects/organizations/${organizationUid}`,
    params,
    addAuthToFetchOpts(accessToken, {})
  ).then(res => res.data);
}

export const useAddResourceMonitorProject = (fetcher = AddResourceMonitorProjectFetcher) => {
  const queryClient = useQueryClient();
  return useMutationWithAuthentication(
    ['add-organization-resource-monitor-project'],
    (accessToken, {params, organizationUid}) => fetcher(accessToken, organizationUid, params),
    {
      onSuccess: (_, {organizationUid}) => {
        queryClient.invalidateQueries('add-organization-resource-monitor-project');
        queryClient.invalidateQueries(['organizations-resource-monitor-projects', organizationUid]);
      }
    }
  )
}
